export const EVENT_TYPE_FIELDS = {
  wedding: {
    eventNameLabel: "Wedding Title",
    hostNameLabel: "Host or Family Name",
    metadataSectionTitle: "Couple Details",
    metadataSectionDescription: "Capture the names and wedding-specific information guests expect to see first.",
    fields: [
      { key: "bride_name", label: "Bride/Partner 1 Name", placeholder: "Bride Name" },
      { key: "groom_name", label: "Groom/Partner 2 Name", placeholder: "Groom Name" },
      { key: "registry_url", label: "Registry Link", placeholder: "https://www.myregistry.com/..." },
    ],
  },
  birthday: {
    eventNameLabel: "Celebration Title",
    hostNameLabel: "Host Name",
    metadataSectionTitle: "Celebration Details",
    metadataSectionDescription: "Add the celebrant and party theme details that personalize the invitation.",
    fields: [
      { key: "birthday_person", label: "Celebrant Name", placeholder: "John Doe" },
      { key: "age_celebrated", label: "Age Turning", placeholder: "30" },
      { key: "theme", label: "Party Theme", placeholder: "Roaring Twenties" },
    ],
  },
  baby_shower: {
    eventNameLabel: "Shower Title",
    hostNameLabel: "Host Name",
    metadataSectionTitle: "Family Details",
    metadataSectionDescription: "Add the parent and shower-specific details that set the tone for the event.",
    fields: [
      { key: "parent_names", label: "Parent Name(s)", placeholder: "Aarav & Meera" },
      { key: "baby_name_optional", label: "Baby Name (Optional)", placeholder: "Baby Sharma" },
      { key: "registry_url", label: "Registry Link", placeholder: "https://www.myregistry.com/..." },
    ],
  },
  graduation: {
    eventNameLabel: "Graduation Title",
    hostNameLabel: "Host Name",
    metadataSectionTitle: "Graduate Details",
    metadataSectionDescription: "Add the graduate and school information that helps guests understand the milestone.",
    fields: [
      { key: "graduate_name", label: "Graduate Name", placeholder: "Priya Shah" },
      { key: "school_name", label: "School or University", placeholder: "Delhi University" },
      { key: "degree_or_class_year", label: "Degree or Class Year", placeholder: "Class of 2026" },
    ],
  },
  housewarming: {
    eventNameLabel: "Housewarming Title",
    hostNameLabel: "Host or Family Name",
    metadataSectionTitle: "Home Details",
    metadataSectionDescription: "Add the household and new-home information guests may need before they arrive.",
    fields: [
      { key: "host_family_name", label: "Host or Family Name", placeholder: "The Patels" },
      { key: "new_home_address", label: "New Home Address", placeholder: "123 Celebration Lane" },
      { key: "housewarming_note", label: "Special Note", placeholder: "Join us as we bless our new home." },
    ],
  },
  cultural_programs: {
    eventNameLabel: "Festival or Program Title",
    hostNameLabel: "Host, Family, or Mandal Name",
    metadataSectionTitle: "Festival Program Details",
    metadataSectionDescription: "Add the devotional or cultural program details guests should know before attending.",
    fields: [
      { key: "program_name", label: "Program or Festival Name", placeholder: "Ganesh Chaturthi Celebration" },
      { key: "host_name", label: "Host, Family, or Mandal Name", placeholder: "The Patil Family" },
      { key: "puja_time", label: "Aarti / Puja Time", placeholder: "7:00 PM" },
      { key: "program_highlights", label: "Program Highlights", placeholder: "Puja, aarti, prasad, and cultural program" },
      { key: "prasad_note", label: "Prasad or Darshan Note", placeholder: "Prasad will be served after aarti" },
      { key: "rsvp_contact", label: "RSVP / Contact", placeholder: "+91 98765 43210" },
    ],
  },
  engagement: {
    eventNameLabel: "Engagement Title",
    hostNameLabel: "Host Name",
    metadataSectionTitle: "Couple Details",
    metadataSectionDescription: "Add the couple details that should appear alongside the engagement celebration.",
    fields: [
      { key: "couple_names", label: "Couple's Names", placeholder: "Alex & Jamie" },
      { key: "original_date", label: "Original Engagement Date", type: "date" },
    ],
  },
  corporate: {
    eventNameLabel: "Event Title",
    hostNameLabel: "Organizer or Team",
    metadataSectionTitle: "Event Details",
    metadataSectionDescription: "Capture the company and event context so the invitation feels polished and professional.",
    fields: [
      { key: "company_name", label: "Company Name", placeholder: "Acme Corp" },
      { key: "event_agenda", label: "Agenda or Focus", placeholder: "Annual offsite and strategy session" },
      { key: "dress_code", label: "Dress Code", placeholder: "Business casual" },
    ],
  },
};

const LEGACY_EVENT_TYPE_ID_MAP = {
  1: "wedding",
  2: "birthday",
  3: "engagement",
};

export function resolveEventTypeKey(event) {
  const eventTypeName = (event?.event_type_name || "")
    .trim()
    .toLowerCase()
    .replace(/[-\s]+/g, "_");
  if (eventTypeName) {
    if (eventTypeName === "marriage") {
      return "wedding";
    }
    if (eventTypeName === "cultural_program" || eventTypeName === "cultural_event") {
      return "cultural_programs";
    }
    return eventTypeName;
  }

  return LEGACY_EVENT_TYPE_ID_MAP[event?.event_type_id] || "";
}

export function getEventTypeFields(event) {
  const eventTypeKey = resolveEventTypeKey(event);
  return EVENT_TYPE_FIELDS[eventTypeKey]?.fields || [];
}

export function getEventTypeFormConfig(event) {
  const eventTypeKey = resolveEventTypeKey(event);
  return (
    EVENT_TYPE_FIELDS[eventTypeKey] || {
      eventNameLabel: "Event Name",
      hostNameLabel: "Host Name",
      metadataSectionTitle: "Event Specific Details",
      metadataSectionDescription: "Add the details that personalize this invitation for guests.",
      fields: [],
    }
  );
}
